module.exports = __webpack_public_path__ + "static/media/logo.60fa6c7c.png";